import { Injectable, isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JornayaService {
  loaded: boolean = false;
  loadedAt: number = null;
  private tokenSelector: string = '[name=universal_leadid]';

  constructor() {
    this.watchForLoaded();
  }

  isLoaded(): boolean {
    if (this.loaded === false) {
      this.loaded = typeof window['LeadiD'] === 'object' && typeof window['LeadiD'].snap === 'function';
    }
    return this.loaded
  }

  watchForLoaded() {
    if (this.loaded === false) {
      setTimeout(function() {
        if (this.isLoaded() === true) {
          this.loadedAt = Date.now();
        } else {
          this.watchForLoaded();
        }
      }.bind(this), 1000);
    }
  }

  /* used for email-verification, not rates-form */
  secondsSinceLoaded():number {
    if (this.loadedAt === null) {
      return null;
    }

    let t = (Date.now() - this.loadedAt) / 1000;

    return Math.floor(t);
  }

  snap() {
    if (this.isLoaded()) {
      window['LeadiD'].snap();
    }
  }

  getToken(): string | null {
    const leadId = document.querySelector(this.tokenSelector) as HTMLInputElement;
    const token = leadId && leadId.value ? leadId.value.trim() : '';

    if (token) {
      window['__jornayaTokenTimedOut'] = false;
    }

    return token || null;
  }

  getTokenStatus(): string {
    if (this.getToken()) {
      return 'token_present';
    }

    if (document.querySelector(this.tokenSelector) === null) {
      return 'token_input_missing';
    }

    if (window['__jornayaTokenTimedOut']) {
      return 'token_timeout';
    }

    if (window['__jornayaScriptLoadFailed']) {
      return 'script_failed_to_load';
    }

    if (this.isLoaded()) {
      return 'script_loaded_token_missing';
    }

    return 'script_not_loaded';
  }

  waitForToken(timeoutMs: number = 5000, intervalMs: number = 200): Promise<string | null> {
    return new Promise(resolve => {
      window['__jornayaTokenTimedOut'] = false;

      const existingToken = this.getToken();
      if (existingToken) {
        resolve(existingToken);
        return;
      }

      if (window['__jornayaScriptLoadFailed']) {
        resolve(null);
        return;
      }

      if (!this.isLoaded()
        && !window['__jornayaScriptLoading']
        && typeof window['__retryJornayaScript'] === 'function'
      ) {
        window['__retryJornayaScript']();
      }

      const interval = setInterval(() => {
        const token = this.getToken();
        if (token) {
          clearInterval(interval);
          clearTimeout(timeout);
          resolve(token);
        } else if (window['__jornayaScriptLoadFailed']) {
          clearInterval(interval);
          clearTimeout(timeout);
          resolve(null);
        }
      }, intervalMs);

      const timeout = setTimeout(() => {
        clearInterval(interval);
        window['__jornayaTokenTimedOut'] = true;
        resolve(null);
      }, timeoutMs);
    });
  }
}
